import {Pipe, PipeTransform} from '@angular/core';

/**
 * Used in *ngIf predicates to determine whether to display empty message.
 *
 * In this case, if items$ hasn't yet emitted a value, the message stays hidden.
 *
 * <div *ngIf="items$ | async | empty>
 *   No items found
 * </div>
 *
 * @returns true if the array is defined and empty,
 *          false if the array is defined an not empty,
 *          undefined if the array is undefined or null
 */
@Pipe({
  name: 'empty',
  standalone: true,
})
export class EmptyPipe implements PipeTransform {
    transform<T>(array?: ReadonlyArray<T>): boolean {
      const length = array?.length;
      return (length !== undefined && length !== null)
        ? length === 0
        : undefined;
    }
}
